import { useEffect, useState } from 'react';
import { opsApi } from '../../api/client';

const LEVEL_COLORS = { info: 'bg-blue-100 text-blue-700', warning: 'bg-amber-100 text-amber-700', error: 'bg-red-100 text-red-700' };

export default function OpsLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    opsApi.aaLogs({ level: filter, limit: 100 }).then(r => {
      if (!cancelled) setLogs(r.data);
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [filter]);

  return (
    <div data-testid="ops-logs" className="p-8">
      <div className="mb-6"><h1 className="text-2xl font-bold text-gray-900">Operational Logs</h1><p className="text-sm text-gray-500 mt-1">Sync events, connector actions, errors</p></div>

      <div className="flex gap-2 mb-6">
        {['', 'info', 'warning', 'error'].map(l => (
          <button key={l} onClick={() => setFilter(l)}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${filter === l ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:border-gray-400'}`}>
            {l || 'All'}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="space-y-2">{[...Array(6)].map((_, i) => <div key={`logs-skeleton-${i}`} className="h-10 bg-gray-100 rounded-lg animate-pulse" />)}</div>
      ) : logs.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><p className="text-gray-400 text-sm">No logs recorded yet</p></div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="divide-y divide-gray-50">
            {logs.map(log => (
              <div key={log._id} className="flex items-start gap-3 px-5 py-3 hover:bg-gray-50/50">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded mt-0.5 shrink-0 ${LEVEL_COLORS[log.level] || 'bg-gray-100 text-gray-500'}`}>{log.level}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-gray-600">{log.type}</span>
                    <span className="text-xs font-mono text-gray-400">{log.reference}</span>
                  </div>
                  <p className="text-sm text-gray-900 mt-0.5">{log.message}</p>
                  {log.detail && <p className="text-xs text-gray-500 mt-0.5 font-mono">{log.detail}</p>}
                </div>
                <span className="text-xs text-gray-400 shrink-0">{log.created_at ? new Date(log.created_at).toLocaleString('nl-BE') : ''}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
